import { checkoutAttemptContext } from './checkoutContext';
import {
  deliveryDetails,
  normalizeDeliveryAddress,
  sameDeliveryDestination,
} from './deliveryAddress';

export const hasDeliveryRevision = (value) =>
  typeof value === 'string' && /^[a-f0-9]{64}$/.test(value);

export const requiresCheckoutResolution = (checkout, mode) =>
  !checkout?.ordinaryCheckout &&
  (mode === 'delivery' ||
    !!checkout?.recovered ||
    hasDeliveryRevision(checkout?.delivery_revision));

export const checkoutRequiresResolution = (state) =>
  requiresCheckoutResolution(
    state.order?.checkoutData,
    state.order?.type?.value
  );

export function deliveryCheckoutMatches(state) {
  const binding = state.order.checkoutDeliveryBinding;
  if (state.order.checkoutData?.ordinaryCheckout) {
    return (
      binding?.ordinary === true &&
      binding.id === state.order.checkoutData.id &&
      checkoutAttemptContext(state, binding.destination) === binding.context
    );
  }
  if (!checkoutRequiresResolution(state)) return true;
  return (
    !!binding &&
    !['pending', 'blocked', 'error'].includes(
      state.order.checkoutDeliveryResult?.status
    ) &&
    state.order.checkoutData?.id === binding.id &&
    state.order.checkoutData?.delivery_revision === binding.revision &&
    hasDeliveryRevision(binding.revision) &&
    checkoutAttemptContext(state, binding.destination) === binding.context
  );
}

export function sameAcknowledgedDestination(expected, actual) {
  const left = normalizeDeliveryAddress(expected);
  const right = normalizeDeliveryAddress(actual);
  return (
    !!left &&
    !!right &&
    sameDeliveryDestination(left, right) &&
    JSON.stringify(deliveryDetails(left.addition)) ===
      JSON.stringify(deliveryDetails(right.addition))
  );
}

export function revisionParameter(checkout) {
  if (
    checkout?.delivery_revision != null &&
    !hasDeliveryRevision(checkout.delivery_revision)
  )
    throw new Error('Invalid checkout revision.');
  return hasDeliveryRevision(checkout?.delivery_revision)
    ? { expected_delivery_revision: checkout.delivery_revision }
    : {};
}

export const paymentResolutionBlocksMutation = (result) =>
  result?.operation_pending ||
  result?.synchronization_allowed === false ||
  !['unpaid', 'action_required', 'canceled', 'expired'].includes(result?.state);
